import React, { useState } from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Label } from "rbx";
import { BooleanInput, SystemCodeSelect } from "../../../components/inputs";

import FilterButtons from "../../../components/FilterButtons";

const INITIAL_FILTER_STATE = { Active: true };

function TariffFilters({ filters, onFilter, onClose }) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const newFilters = {
      ...inputs
    };
    if (e.target.name === "TariffTypeRecIdRef") {
      const v = parseInt(value);
      newFilters.TariffTypeRecIdRef = v !== 0 ? v : null;
    } else {
      newFilters[e.target.name] = value;
    }
    setInputs(newFilters);
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Column.Group>
        <Column>
          <Field>
            <Control>
              <SystemCodeSelect
                icon="globe"
                label="Tariff Type"
                lookup={{ Category: "Tariff", Code: "TariffType" }}
                name="TariffTypeRecIdRef"
                showHelp={false}
                value={inputs.TariffTypeRecIdRef}
                valueKey="RecId"
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>Active</Label>
              <BooleanInput
                name="Active"
                value={inputs.Active}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
}
TariffFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
export default TariffFilters;
